import { useAppSelector } from '@/store';
import { useUnpublishMarketingListingMutation } from '@/store/api/services/marketing/marketing';
import type { ListingView } from '@/types';
import { authReducer } from '@bitstopco/bitstop-theme';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';
import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import toast from 'react-hot-toast';

const UnpublishMarketingListing = ({ hide, props }: ModalChildrenProps) => {
  const item = props?.data as ListingView;
  const [unpublishListing, { isLoading }] = useUnpublishMarketingListingMutation();
  const {
    selectors: { userInfo },
  } = authReducer;
  const userData = useAppSelector(userInfo);

  const handleSubmit = async () => {
    try {
      await unpublishListing({
        locationId: item.location_id,
        user: `${userData?.first_name} ${userData?.last_name}`,
      }).unwrap();
      hide();
      toast.success(`${item.name ?? `Location ${item.location_id}`} unpublished successfully.`);
    } catch (_err) {
      toast.error('Failed to unpublish listing.');
    }
  };

  return (
    <>
      <DialogContent sx={{ my: 2 }}>
        <Typography variant="h6">Unpublish Listing</Typography>
        <Typography mt={1} variant="body1">
          Are you sure you want to unpublish <b>{item?.name ?? `Location ${item?.location_id}`}</b>?
        </Typography>
        <Typography mt={1} variant="body2" color="text.secondary">
          This will remove the listing from all Bitstop maps. You can re-publish it at any time.
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Cancel</Button>
        <LoadingButton color="error" variant="contained" onClick={handleSubmit} loading={isLoading}>
          Unpublish
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default UnpublishMarketingListing;
